var _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLessons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".st1{fill:#e79933}.st2{fill:#48b2d2}.st3{fill:#65ab65}")), /*#__PURE__*/React.createElement("path", {
    d: "M307.975 69.357c-137.968 0-250.22 106.934-250.22 238.393 0 131.46 112.252 238.394 250.22 238.394 137.986 0 250.238-106.935 250.238-238.394S445.96 69.357 307.975 69.357zm0 392.634c-89.276 0-161.887-69.198-161.887-154.24 0-85.043 72.63-154.24 161.887-154.24 89.275 0 161.905 69.197 161.905 154.24 0 85.042-72.63 154.24-161.905 154.24z",
    id: "path4",
    style: {
      strokeWidth: 1.77839,
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 261.096,
    cy: 336.472,
    r: 19.705,
    id: "circle6",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 261.096,
    cy: 395.603,
    r: 19.705,
    id: "circle8",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 261.096,
    cy: 277.358,
    r: 19.705,
    id: "circle10",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 261.096,
    cy: 218.226,
    r: 19.705,
    id: "circle12",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 307.015,
    cy: 310.418,
    r: 19.705,
    id: "circle14",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 307.015,
    cy: 369.532,
    r: 19.705,
    id: "circle16",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 307.015,
    cy: 251.286,
    r: 19.705,
    id: "circle18",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 353.68,
    cy: 339.726,
    r: 19.705,
    id: "circle20",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 353.68,
    cy: 280.594,
    r: 19.705,
    id: "circle22",
    style: {
      strokeWidth: 1.77839
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.815,
    cy: 310.863,
    r: 19.705,
    id: "circle24",
    style: {
      strokeWidth: 1.77839,
      fill: "#de7c73"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessons);
export default __webpack_public_path__ + "static/media/lessons.b5f52c06a4183b79a3d75c6aecfc2dbc.svg";
export { ForwardRef as ReactComponent };